<template>


  <div>
    <div
      id="uoloaddiv"
      v-loading.fullscreen.lock="loading"
      element-loading-text="Waiting...."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
<!--     <el-row >
        <el-button  type="text" round icon="el-icon-time"   >本机时间： {{localtime}}</el-button>
        <el-button  type="text" round icon="el-icon-time"   >NSP系统时间： {{systemtime}}</el-button>
        <el-button   round icon="el-icon-d-arrow-right"  @click="gotimesave"   >同步本机时间到NSP服务</el-button>
      </el-row> -->
      <el-row>
        <el-button
          size="medium"
          icon="el-icon-plus"
          @click="creatTask()"
          type="primary"
        >创建任务</el-button>
        <el-button
          size="medium"
          icon="el-icon-refresh"
          @click="_get_timer_tasklist"
          type="success"
        >手動刷新</el-button>
        <el-select v-model="taskgroupv" placeholder="ALL全部">
            <el-option
              v-for="item in options_taskgroup"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled">
            </el-option>
          </el-select>
          <el-button
            size="medium"
            @click="_add_taskgroup"
            type="success"
          >Add_Plan组方案</el-button>
          <el-button
            size="medium"
            @click="_del_taskgroup_ap"
            type="success"
          >Del_Plan组方案</el-button>
          <el-button
            size="medium"
            @click="_disab_taskgroup"
            type="success"
          >组方案禁Disable</el-button>
          <el-button
            size="medium"
            @click="_eab_taskgroup"
            type="success"
          >组方案生效Enable</el-button>
      </el-row>
      <el-dialog
        title="添加任务组[Add task Group]"
        :visible.sync="dialogVisible_addtaskgroup"
        width="30%"
        >
        <el-input placeholder="" v-model="NewtaskGoupname" maxlength=15 show-word-limit>
            <template slot="prepend">任务组名字[New task group name]:</template>
          </el-input>

          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible_addtaskgroup = false">取 消[Cancel]</el-button>
            <el-button type="primary" @click="_add_taskgroup_ap">确 定[Apply]</el-button>
          </span>
      </el-dialog>
      <el-dialog
        title="应用任务组[Apply task Group]"
        :visible.sync="dialogVisible_edgtaskgroup"
        width="30%"
        >
        <el-row>
          <span>为任务：{{edgtaskname}} --{{edgtaskid}}  选择应用分组</span>
          <el-select v-model="taskgroupvv" placeholder="ALL全部">
              <el-option
                v-for="item in options_taskgroup"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled">
              </el-option>
            </el-select>
        </el-row>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible_edgtaskgroup = false">取 消[Cancel]</el-button>
            <el-button type="primary" @click="_edg_taskgroup_ap">确 定[Apply]</el-button>
          </span>
      </el-dialog>
      <br />
      <br />
      <el-table :data="tableDatatasklist" border>
        <el-table-column type="index" width="50px" label="编号"></el-table-column>
        <el-table-column prop="id" label="ID" width="50px"></el-table-column>
        <el-table-column prop="task_name" label="任务名" width="200px"></el-table-column>
        <el-table-column prop="tasktime" label="启动时间" width="100px"></el-table-column>
        <el-table-column prop="len" label="时长[秒]" width="100px"></el-table-column>
        <el-table-column prop="kind" label="循环次数" width="130px">
            <template slot-scope="scope">
             <span v-if="tableDatatasklist[scope.$index].kind == 0"> 随机播放 </span>
             <span v-if="tableDatatasklist[scope.$index].kind > 0"> 循环{{tableDatatasklist[scope.$index].kind}}遍 </span>
            </template>
        </el-table-column>
        <el-table-column prop="startdate" label="开始日期" width="100px"></el-table-column>
        <el-table-column prop="enddate" label="停止日期" width="100px"></el-table-column>
        <el-table-column prop="gname" label="任务方案组[GPLAN]" width="200px">
           <template slot-scope="scope">
            <el-button
              @click.native.prevent="edgtask(scope.$index, tableDatatasklist)"
              type="text"
              size="small"
            >ChangeGP </el-button>
            <span v-if="tableDatatasklist[scope.$index].groupid == 0 ">尚未归组</span>
            <span  v-if="tableDatatasklist[scope.$index].groupid > 0 ">{{  taskgpnamelist[ tableDatatasklist[scope.$index].groupid ] }}  </span>
           </template>
        </el-table-column>
        <el-table-column label="[删]-[启/禁-用]-[改]" align="center" width="150px">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="deletetask(scope.$index, tableDatatasklist)"
              type="text"
              size="small"
            >删除</el-button>
          <!--  <el-button
              @click.native.prevent="deletetaskS(scope, tableDatatasklist)"
              type="text"
              size="small"
            >test</el-button>   -->
          <!--  <el-switch
              active-value=1
              inactive-value=0
              v-model="scope.row.enable"
              @change="abletask( scope.$index , tableDatatasklist )"
            ></el-switch>   -->
            <el-switch
                active-value=1
                inactive-value=0
                v-model="tableDatatasklist[scope.$index].enable"
                @change="abletask( scope.$index , tableDatatasklist )"
              ></el-switch>
            <el-button
              @click.native.prevent="go_edit_task(scope.$index, tableDatatasklist)"
              type="text"
              size="small"
            >修改</el-button>
          </template>

        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <el-button
              v-show="scope.row.statu==0"
              @click.native.prevent="startTask(scope.$index, tableDatatasklist)"
              type="success"
              size="small"
              plain
            >试听</el-button>
            <el-button
              v-show="scope.row.statu==1"
              @click.native.prevent="stopTask(scope.$index, tableDatatasklist)"
              type="warning"
              size="small"
              plain
            >停止</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>

















      <el-dialog :title="dialog_titel" :visible.sync="dialogVisible_addtask" width="1000px">
                <div
                  id="uoloaddiv2"
                  v-loading.fullscreen.lock="loading2"
                  element-loading-text="Waiting...."
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(0, 0, 0, 0.8)"
                >
                </div>
                <el-form ref="form" :model="form" label-width="80px" align="left">
                  <el-row  >
                    <el-form-item label="任务名称">
                      <el-col :span="6">
                        <el-input v-model="form.name" style="width: 300"></el-input>
                      </el-col>
                      <el-col :span="2">
                        <span>&ensp;</span>
                      </el-col>
                      <el-col :span="4">
                        <el-button @click="edit_taskname"   v-if="form.isedit_mode == true"   type="danger" >修改</el-button>
                      </el-col>
                    </el-form-item>

                  </el-row>
                  <el-form-item label="其他限制">
                    <el-switch
                      v-model="falss"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      active-text="限制条件非必须不要设置" >
                    </el-switch>
                  </el-form-item>
                 <!-- <el-form-item label="节点选择">
                      <el-select
                        v-model="form.nodeid"
                        @change="nodechange_"
                        placeholder="请选择网络节点"
                        :disabled="dialog_titel=='修改任务'"
                      >
                      <el-option
                        v-for="(item,index) in tableData1"
                        :label="item.node_name"
                        :value="item.id"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </el-form-item> -->
                  <el-row  v-if="falss">
                    <el-form-item label="选择日期">
                      <el-col :span="3">
                        <el-checkbox   v-model="checked1">启用开始日期</el-checkbox>
                      </el-col>
                      <el-col :span="6">
                        <el-date-picker
                          v-model="form.startDate"
                          type="date"
                          placeholder="选择日期"
                          :disabled="!checked1"
                          :picker-options="pickerOptions1"
                        ></el-date-picker>
                      </el-col>

                      <el-col :span="3">
                       &ensp;&ensp; <el-button @click="edit_task_startdate"   v-if="form.isedit_mode == true"   type="danger" >修改</el-button>
                      </el-col>
                    </el-form-item>
                  </el-row>
                  <el-form-item>
                    <el-row v-if="falss">
                      <el-col :span="3">
                        <el-checkbox   v-model="checked2">启用结束日期</el-checkbox>
                      </el-col>
                      <el-col :span="6">
                        <el-date-picker
                          v-model="form.endDate"
                          type="date"
                          placeholder="选择日期"
                          :disabled="!checked2"
                          :picker-options="pickerOptions2"
                        ></el-date-picker>
                      </el-col>
                      <el-col :span="3">
                       &ensp;&ensp; <el-button @click="edit_task_enddate"   v-if="form.isedit_mode == true"   type="danger" >修改</el-button>
                      </el-col>
                    </el-row>
                  </el-form-item>
                  <el-form-item label="开始时间"  v-show="form.kind>=1" >
                    <el-time-picker v-model="form.startTime"
                      @change='Timerpickerchange'
                      placeholder="任意时间点" ></el-time-picker> &ensp;&ensp;
                     <el-button @click="edit_taskstarttime"   v-if="form.isedit_mode == true"   type="danger" >修改</el-button>
                  </el-form-item>
                  <el-form-item label="任务周期">
                    <el-checkbox v-model="week[0]" name="type1">周一</el-checkbox>
                    <el-checkbox v-model="week[1]" name="type2">周二</el-checkbox>
                    <el-checkbox v-model="week[2]" name="type3">周三</el-checkbox>
                    <el-checkbox v-model="week[3]" name="type4">周四</el-checkbox>
                    <el-checkbox v-model="week[4]" name="type5">周五</el-checkbox>
                    <el-checkbox v-model="week[5]" name="type6">周六</el-checkbox>
                    <el-checkbox v-model="week[6]" name="type7">周日</el-checkbox> &ensp;&ensp;&ensp;
                    <el-button @click="edit_taskweeks"   v-if="form.isedit_mode == true"   type="danger" >修改</el-button>
                  </el-form-item>
                  <h3 style="margin: 50px 0 20px">选择需要播放的设备</h3>
                  <div>
                    <el-transfer
                      style="text-align: left; display: inline-block"
                      v-model="form.seedlist.value"
                      filterable
                      :titles="['所有设备', '被播放的设备']"
                      :button-texts="['移除', '添加']"
                      :format="{
                        noChecked: '${total}',
                        hasChecked: '${checked}/${total}'
                      }"
                      :data="form.seedlist.data"
                    >
                    <span slot-scope="{option}">{{ option.label }}</span>
                    </el-transfer>&ensp;&ensp;
                    <el-button @click="edit_taskdevices"   v-if="form.isedit_mode == true"   type="danger" >修改任务设备</el-button>
                  </div>
                  <h3 style="margin: 50px 0 20px">选择任务音频文件</h3>
                  <div >
                    <el-row>
                        <div style="text-align: left;">
                            <myTransfer  style="text-align: left;  " v-model="form.filelist.value" :inputList="form.filelist.data">
                                <span slot-scope="{option}">{{ option.label }}</span>
                            </myTransfer>
                        </div>
                    </el-row>
                    <el-row>
                        <el-col :span="6"> &ensp;</el-col>
                        <el-col :span="3">
                          <el-button @click="edit_taskfiles"   v-if="form.isedit_mode == true"   type="danger" >修改任务播放文件</el-button>
                        </el-col>
                    </el-row>
                  <br>
                  </div>
                  <br>
                  <el-row  >
                    <el-form-item label="任务时长" v-show="form.kind==1" >
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="以秒为单位;顺序播放次数循环时长如果比设置时长短会提前终止,以此处总时长为准,此处为0,则循环结束即停止;"
                        placement="right-start"
                      >
                        <el-input-number v-model="form.len" :min="form.kind==1?0:600" :max="72000" :disabled="true" >
                        </el-input-number>
                      </el-tooltip>
                      <el-button @click="countLength">计算</el-button>
                    </el-form-item>
                    <el-form-item label="间隔时长"  >
                        <el-tooltip
                          class="item"
                          effect="dark"
                          content="播放完一个节目之后间隔多少秒播放下一个条目"
                          placement="right-start">
                          <el-input-number v-model="form.jiange" :min="1" @change="countLength"></el-input-number>
                        </el-tooltip>
                        &ensp;&ensp;&ensp;
                        <el-button @click="edit_taskjiange"   v-if="form.isedit_mode == true"   type="danger" >修改</el-button>
                    </el-form-item>
                  </el-row>
                    <el-form-item label="时间选择"  v-show="form.kind==0" >
                      <el-time-picker v-model="form.timepicker"  is-range  range-separator="至"
                          placeholder="任意时间点" ></el-time-picker>

                          &ensp;&ensp;
                      <el-button @click="edit_tasksj_len"   v-if="form.isedit_mode == true"   type="danger" >修改</el-button>
                    </el-form-item>

                    <el-row class="fucko">
                      <el-col :span="5" v-if="form.isedit_mode == false" >
                        <el-form-item label="播放模式"  >
                          <el-select v-model="form.kind" @change="task_mode_change" placeholder="请选择任务类型">
                            <el-option label="顺序播放" value=1></el-option>
                            <el-option label="随机播放" value=0></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="9">
                        <el-form-item label="播放次数" v-show="form.kind==1" >
                          <el-row>
                            <el-input-number v-model="form.num" :min="1" @change="countLength" ></el-input-number>
                            <el-button @click="task_cishu"  type="danger"  v-if="form.isedit_mode == true"  >修改</el-button>
                          </el-row>
                        </el-form-item>
                      </el-col>
                    </el-row>
                </el-form>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="dialogVisible_addtask=false" v-if="form.isedit_mode == false">取 消</el-button>
                  <el-button @click="dialogVisible_addtask=false"  v-if="form.isedit_mode == true"  type="danger" >关闭</el-button>
                  <el-button type="primary" @click="save_task" v-if="form.isedit_mode == false">确 定</el-button>
                </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import myTransfer from './myTransfer.vue';
import axios from "axios";
axios.defaults.headers = {
  "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
};
let Base64 = require("js-base64").Base64;
var systemtimed = new Date();
function dateAdd(d,num){
    var countsys  = new Date(d) ;
    systemtimed.setTime( countsys.getTime() + 1000 );
    return systemtimed.toString();
}
var localtimec1;
var systemtimec1;
export default {
  data() {
	return {
      options_taskgroup:[
        {
          value:  0,
          label: '全部任务分组[ALLtaskGP]'
        }
      ],
      loading2:false,
      nums: 1,
      falss:false,
      dialogVisible_addtaskgroup:false,
      dialogVisible_edgtaskgroup:false,
      taskgroupv:0,
      taskgroupvv:0,
      localtime:"111",
      systemtime:"2222",
      edgtaskid:0,
      edgtaskname:"",
      NewtaskGoupname:"",
      loading: false,
      tableDatatasklist: [],
      dialogVisible_addtask: false,
      dialog_titel: "创建任务",
      checked1: "",
      checked2: "",
      is_create: true,
      upDownDisable:true,
      tempSelectionKeys:[],
      outputListTemp:[],
      week: [true, true, true, true, true, true, true],
      form: {
        id: "",
        name: "",
        nodeid: "",
        startDate: "",
        endDate: "",
        estartDate: 0,
        eendDate: 0,
        kind: "1" ,
        num: 1,
        startTime: {},
        timepicker: [new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)],
        len: 0,
        nsptime:"2022-01-01 00:00:00",
        jiange: 1,
        weekStr: "",
        seedlist: {
          data: [],
          value: []
        },
        filelist: {
          data: [],
          value: []
        },
        taskEnable: "1",
        isedit_mode : false
      },
      tableData1: [],
      tableData2: [],
      tableDatafilelist: [],
      taskgpnamelist:[],
      pickerOptions1: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "一周后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            }
          },
          {
            text: "一个月后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit("pick", date);
            }
          },
          {
            text: "二个月后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 60);
              picker.$emit("pick", date);
            }
          },
          {
            text: "三个月后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 91);
              picker.$emit("pick", date);
            }
          },
          {
            text: "六个月后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 182);
              picker.$emit("pick", date);
            }
          },
          {
            text: "十二个月后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 365);
              picker.$emit("pick", date);

            }
          }
        ]
      },

      pickerOptions2: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "一周后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            }
          },
          {
            text: "一个月后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit("pick", date);
            }
          },
          {
            text: "二个月后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 60);
              picker.$emit("pick", date);
            }
          },
          {
            text: "三个月后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 91);
              picker.$emit("pick", date);
            }
          },
          {
            text: "六个月后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 182);
              picker.$emit("pick", date);
            }
          },
          {
            text: "十二个月后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 365);
              picker.$emit("pick", date);
            }
          }
        ]
      }
    };
  },

 watch:{
	 "form.filelist.value": {
        deep: true,
        handler: function (newVal,oldVal){
          this.countLength();
        }
      }
 },
  created() {
    this._get_timer_tasklist();
    //this.get_devlist();
    //this.get_file_list();
    this.get_taskgroup_ap();
    //this.get_nsptime();
    localtimec1 = self.setInterval(() => {
      //需要定时执行的代码
      var localtimed = new Date();
      this.localtime = localtimed.toString();
    }, 1000)

    systemtimec1 =  self.setInterval(() => {
      this.systemtime = dateAdd(this.systemtime,1);
     // console.log(this.systemtime);
    }, 1000)

  },
  components: {
    myTransfer
  },
  methods: {
        edit_task_enddate(){
            var enddate =  "2025-01-01"
            if(this.checked2 && typeof(this.form.endDate)!="undefined" ){
              enddate = this.form.endDate.getFullYear()+"-"+(this.form.endDate.getMonth())+"-"+this.form.endDate.getDate();
            }else{
              console.log("enddate：undefined");

            }
            console.log("enddate："+enddate);
            this.loading2 = true;
            let data = new FormData();
            data.append("id", sessionStorage.getItem("id"));
            data.append("token", sessionStorage.getItem("token"));
            data.append("taskid",this.form.id );
            data.append("enddate", enddate);
            axios
              .post("/user/edit_task", data)
              .then(
                function(res) {
                  this.dialogVisible_addtask=false
                  if (res.data.res) {
                    console.log(res.data);
                  }
                  setTimeout(() => {
                    this.loading2 = false;
                    this.dialogVisible_addtask=false
                    this._get_timer_tasklist();
                  }, 4000);
                }.bind(this)
              )
              .catch(function(res) {
                console.log(res);
              });
        },
        edit_task_startdate(){
            var startdate = "2025-01-01"
            if(this.checked1 && typeof(this.form.startDate)!="undefined" ){
              startdate = this.form.startDate.getFullYear()+"-"+this.form.startDate.getMonth()+"-"+this.form.startDate.getDate();
            }else{
              console.log("startDate：undefined");
            }
            console.log("startdate:"+startdate);
            this.loading2 = true;
            let data = new FormData();
            data.append("id", sessionStorage.getItem("id"));
            data.append("token", sessionStorage.getItem("token"));
            data.append("taskid",this.form.id );
            data.append("startdate", startdate);
            axios
              .post("/user/edit_task", data)
              .then(
                function(res) {
                  this.dialogVisible_addtask=false
                  if (res.data.res) {
                    console.log(res.data);
                  }
                  setTimeout(() => {
                    this.loading2 = false;
                    this.dialogVisible_addtask=false
                    this._get_timer_tasklist();
                  }, 4000);
                }.bind(this)
              ).catch(function(res) {
                console.log(res);
              });
        },
        edit_tasksj_len(){
            console.log(this.form.kind);
            console.log(this.form.num);
            if(this.form.kind != "0"  ){
              return;
            }
            console.log("==>" , this.form.timepicker[0].toTimeString() ,this.form.timepicker[1].toTimeString()    );
            console.log("==>" , this.form.timepicker[0].toString() ,this.form.timepicker[1].toString()    );
            var l1 = this.form.timepicker[0].getHours()*3600+this.form.timepicker[0].getMinutes()*60+this.form.timepicker[0].getSeconds();
            var l2 = this.form.timepicker[1].getHours()*3600+this.form.timepicker[1].getMinutes()*60+this.form.timepicker[1].getSeconds();
            var len = l2 - l1;
            console.log("==>" , l1 ,l2  ,len );

            if(len < 10 ){
              this.$message({                type: "warning",                message: "任务时长不能小于10秒"              });
              return ;
            }
            console.log("sjlen:"+this.form.len);
            this.loading2 = true;
            let data = new FormData();
            data.append("id", sessionStorage.getItem("id"));
            data.append("token", sessionStorage.getItem("token"));
            data.append("taskid",this.form.id );
            data.append("len", len);
            var start_time = this.form.timepicker[0].getHours() +":"+this.form.timepicker[0].getMinutes()+":"+this.form.timepicker[0].getSeconds();
            data.append("start_time", start_time);
            axios
              .post("/user/edit_task", data)
              .then(
                function(res) {
                  this.dialogVisible_addtask=false
                  if (res.data.res) {
                    console.log(res.data);
                  }
                  setTimeout(() => {
                    this.loading2 = false;
                    this.dialogVisible_addtask=false
                    this._get_timer_tasklist();
                  }, 4000);
                }.bind(this)
              )
              .catch(function(res) {
                console.log(res);
              });
        },
        task_cishu(){
          if(this.form.num < 2){
             this.form.num =1;
          }
          console.log("num:"+this.form.num);
          this.loading2 = true;
          let data = new FormData();
          data.append("id", sessionStorage.getItem("id"));
          data.append("token", sessionStorage.getItem("token"));
          data.append("taskid",this.form.id );
          data.append("kind",this.form.num );
          if(this.form.num > 0){
            data.append("len",this.form.len );
          }
          axios
            .post("/user/edit_task", data)
            .then(
              function(res) {
                this.dialogVisible_addtask=false
                if (res.data.res) {
                  console.log(res.data);
                }
                setTimeout(() => {
                  this.loading2 = false;
                  this.dialogVisible_addtask=false
                  this._get_timer_tasklist();
                }, 4000);
              }.bind(this)
            )
            .catch(function(res) {
              console.log(res);
            });
        },
        edit_taskjiange(){
          if(this.form.jiange < 2){
             this.form.jiange =2;
          }
          console.log("jiange"+this.form.jiange);
          this.loading2 = true;
          let data = new FormData();
          data.append("id", sessionStorage.getItem("id"));
          data.append("token", sessionStorage.getItem("token"));
          data.append("taskid",this.form.id );
          data.append("jiange",this.form.jiange );
          if(this.form.num > 0){
            data.append("len",this.form.len );
          }
          axios
            .post("/user/edit_task", data)
            .then(
              function(res) {
                this.dialogVisible_addtask=false
                if (res.data.res) {

                }
                setTimeout(() => {
                  this.loading2 = false;
                  this.dialogVisible_addtask=false
                  this._get_timer_tasklist();
                }, 4000);
              }.bind(this)
            )
            .catch(function(res) {
              console.log(res);
            });
        },
        edit_taskweeks(){
            this.form.weekStr = "";
            for (var i = 0; i < this.week.length; i++) {
              if(this.week[i]){
                this.form.weekStr +="1";
              }else{
                this.form.weekStr += "0";
              }
            }
            console.log("weekStr"+this.form.weekStr);
            this.loading2 = true;
            let data = new FormData();
            data.append("id", sessionStorage.getItem("id"));
            data.append("token", sessionStorage.getItem("token"));
            data.append("taskid",this.form.id );
            data.append("week",this.form.weekStr );
            axios
              .post("/user/edit_task", data)
              .then(
                function(res) {
                  this.dialogVisible_addtask=false
                  if (res.data.res) {
                    console.log(res.data);
                  }
                  setTimeout(() => {
                    this.loading2 = false;
                    this.dialogVisible_addtask=false
                    this._get_timer_tasklist();
                  }, 4000);
                }.bind(this)
              )
              .catch(function(res) {
                console.log(res);
              });
        },
        edit_taskstarttime(){
          console.log("task_starttime"+this.form.startTime);
          var startI = this.form.startTime.getHours()+":"+this.form.startTime.getMinutes()+":"+this.form.startTime.getSeconds();
          console.log(startI);
          this.loading2 = true;
          let data = new FormData();
          data.append("id", sessionStorage.getItem("id"));
          data.append("token", sessionStorage.getItem("token"));
          data.append("taskid",this.form.id );
          data.append("start_time",startI );
          axios
            .post("/user/edit_task", data)
            .then(
              function(res) {
                this.dialogVisible_addtask=false
                if (res.data.res) {
                  console.log(res.data);
                }
                setTimeout(() => {
                  this.loading2 = false;
                  this.dialogVisible_addtask=false
                  this._get_timer_tasklist();
                }, 4000);
              }.bind(this)
            )
            .catch(function(res) {
              console.log(res);
            });
        },
        edit_taskname(){
          console.log("taskid"+this.form.id);
          if(this.form.name.length<2){
            return;
          }
          this.loading2 = true;
          let data = new FormData();
          data.append("id", sessionStorage.getItem("id"));
          data.append("token", sessionStorage.getItem("token"));
          data.append("taskid",this.form.id );
          data.append("task_name",this.form.name );
          axios
            .post("/user/edit_task", data)
            .then(
              function(res) {
                this.dialogVisible_addtask=false
                if (res.data.res) {
                  console.log(res.data);
                }
                setTimeout(() => {
                  this.loading2 = false;
                  this.dialogVisible_addtask=false
                  this._get_timer_tasklist();
                }, 4000);
              }.bind(this)
            )
            .catch(function(res) {
              console.log(res);
            });
        },
        get_nowtask_detail( taskid ){
            console.log("taskid"+this.form.id);

            this.loading2 = true;
            let data = new FormData();
            data.append("id", sessionStorage.getItem("id"));
            data.append("token", sessionStorage.getItem("token"));
            data.append("taskid",this.form.id );
            axios
              .post("/user/getone_task", data)
              .then(
                function(res) {
                  if (res.data.res) {
                    console.log(res.data);
                    /*
            this.form.seedlist.value = rows[index].seedidary;
            this.form.filelist.value = rows[index].fileidary;
                    */
                   this.form.filelist.value = [];
                   this.form.seedlist.value = [];
                    if(res.data.devlistary.length > 0){
                      res.data.devlistary.forEach((item,index)=>{
                        this.form.seedlist.value.push(item.devseedid);
                      });
                    }
                    if(res.data.filelistary.length > 0){
                      res.data.filelistary.forEach((item,index)=>{
                        this.form.filelist.value.push(item.id);
                      });
                    }
                  }
                  setTimeout(() => {
                    this.loading2 = false;
                  }, 1000);
                }.bind(this)
              )
              .catch(function(res) {
                console.log(res);
              });
        },
        go_edit_task(index, rows) {
            this.form.isedit_mode = true;
            console.log(rows[index]);
            this.form.id = rows[index].id;
            this.form.name = rows[index].task_name;
            this.form.nodeid = rows[index].nodeid;
            if(rows[index].kind == 0 ){
              this.form.kind ="0";
            }else{
              this.form.kind ="1";
            }
            this.form.num = rows[index].kind;
            this.form.len = rows[index].len;
            this.form.jiange = rows[index].jiange;
            this.form.taskEnable = rows[index].enable;
            this.is_create = false;
            if (rows[index].startdate_ == "无限制") {
              this.checked1 = false;
            } else {
              this.checked1 = true;
              this.form.startDate = rows[index].startdate_;
            }
            if (rows[index].enddate_ == "无限制") {
              this.checked2 = false;
            } else {
              this.checked2 = true;
              this.form.endDate = rows[index].enddate_;
            }

            var tmpdate = new Date();
            var stattTime2 =  tmpdate.getFullYear()+"-"+tmpdate.getMonth()+"-"+tmpdate.getDate()+" "+rows[index].tasktime ;
            var dateary=[];
            console.log( rows[index].tasktime );

            this.form.startTime = new Date(stattTime2);// new Date(stattTime2 + stattTime1);parseInt(rows[index].start_time) * 1000;
            var dte2 = new Date(this.form.startTime.getTime()+parseInt(rows[index].len)*1000);
            if(rows[index].kind == 0){
              dateary.push(this.form.startTime);
              dateary.push(dte2);
              this.form.timepicker = dateary;
            }

            console.log( rows[index].tasktime );
            for (var i = 0; i < rows[index].week.length; i++) {
              if (rows[index].week.charAt(i) == 0) {
                this.week[i] = false;
              } else {
                this.week[i] = true;
              }
            }
            this.nodechange_();
            this.get_file_list();
            this.get_nowtask_detail(this.form.id);
            this.dialog_titel = "修改任务";
            if(rows[index].enddate != "无限制"){
              this.form.endDate = new Date(rows[index].enddate +" 00:00:00");
            }
            if(rows[index].startdate != "无限制"){
              this.form.startDate = new Date(rows[index].startdate +" 00:00:00");
            }
            this.dialogVisible_addtask = true;
    },

    stopTask(index, rows) {
      this.loading = true;
      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("token", sessionStorage.getItem("token"));
      data.append("taskid",rows[index].id  );
      axios
        .post("/user/stoptask", data)
        .then(
          function(res) {
            if (res.data.res) {
              console.log(res.data);
            }
            setTimeout(() => {
              this.loading = false;
              this._get_timer_tasklist();
            }, 4000);
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    startTask(index, rows) {
      this.loading = true;
      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("token", sessionStorage.getItem("token"));
      data.append("taskid",rows[index].id  );
      axios
        .post("/user/starttask", data)
        .then(
          function(res) {
            if (res.data.res) {
              console.log(res.data);
            }
            setTimeout(() => {
              this.loading = false;
              this._get_timer_tasklist();
            }, 3000);
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    edit_taskfiles(){
      if(this.form.filelist.value.length == 0 ){
         return;
      }
      var arrfile = [];
      for (var i in this.form.filelist.value) {
        arrfile.push(this.form.filelist.value[i]);
      }
      var fileidlist = arrfile.join("|");
      console.log(fileidlist);
      this.loading2 = true;
      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("token", sessionStorage.getItem("token"));
      data.append("taskid",this.form.id );
      data.append("fileids", fileidlist);
      axios
        .post("/user/editfiles_task", data)
        .then(
          function(res) {
            this.dialogVisible_addtask=false
            if (res.data.res) {
              console.log(res.data);
            }
            setTimeout(() => {
              this.loading2 = false;
              this.dialogVisible_addtask=false
              this._get_timer_tasklist();
            }, 4000);
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    edit_taskdevices(){
        if(this.form.seedlist.value.length == 0){
          return;
        }
        var seedidlist = this.form.seedlist.value.join("|");
        console.log("seedidlist："+seedidlist);
        this.loading2 = true;
        let data = new FormData();
        data.append("id", sessionStorage.getItem("id"));
        data.append("token", sessionStorage.getItem("token"));
        data.append("taskid",this.form.id );
        data.append("snids", seedidlist);
        axios
          .post("/user/editsns_task", data)
          .then(
            function(res) {
              this.dialogVisible_addtask=false
              if (res.data.res) {
                console.log(res.data);
              }
              setTimeout(() => {
                this.loading2 = false;
                this.dialogVisible_addtask=false
                this._get_timer_tasklist();
              }, 4000);
            }.bind(this)
          )
          .catch(function(res) {
            console.log(res);
          });
    },
    save_task() {
      if (this.form.name == "") {
        this.$message({
          type: "warning",
          message: "任务名字不能为空"
        });
        return;
      }
      // if (this.form.nodeid == "") {
      //   this.$message({
      //     type: "warning",
      //     message: "没有选择该任务的网络节点"
      //   });
      //   return;
      // }
      if (this.form.seedlist.value.length == 0) {
        this.$message({
          type: "warning",
          message: "没有选择播放设备"
        });
        return;
      }
      if (this.form.filelist.value.length == 0) {
        this.$message({
          type: "warning",
          message: "没有选择播放的音频文件"
        });
        return;
      }
      if (this.form.kind == "0") {
        this.form.startTime =  this.form.timepicker[0];
      }
      if (this.form.startTime == null || this.form.startTime == 0) {
        this.$message({
          type: "warning",
          message: "没有选择播放开始时间"
        });
        return;
      }
      if (this.form.kind == "") {
        this.$message({
          type: "warning",
          message: "没有选择播放模式"
        });
        return;
      }

      if (!this.checked1) {
        this.form.estartDate = "";
      } else if (this.form.startDate != "") {
        var datestart = new Date(this.form.startDate);
        // console.log(datestart);
        //this.form.estartDate = parseInt(          datestart.getTime() / (3600 * 24 * 1000)        );
        this.form.estartDate = datestart.getFullYear()+"-"+datestart.getMonth()+"-"+datestart.getDate();
      } else {
        this.form.estartDate = "";
      }
      if (!this.checked2) {
        //this.form.eendDate = 0;
        this.form.eendDate = "";
      } else if (this.form.endDate != "") {
        var dateend = new Date(this.form.endDate);
        this.form.eendDate = dateend.getFullYear()+"-"+dateend.getMonth()+"-"+dateend.getDate();
      } else {
        this.form.eendDate = "";
      }
      if (this.form.kind == "1") {
        if (this.form.len < 20) {
          this.form.len = 20;
        }
      }

      if (this.form.kind == "0") {
        this.form.startTime =  this.form.timepicker[0];
        var l1 = this.form.timepicker[0].getHours()*3600+this.form.timepicker[0].getMinutes()*60+this.form.timepicker[0].getSeconds();
        var l2 = this.form.timepicker[1].getHours()*3600+this.form.timepicker[1].getMinutes()*60+this.form.timepicker[1].getSeconds();
        this.form.len = l2 - l1;
        if (this.form.len < 10) {
          this.form.len = 10;
        }
        this.form.num=0;
      }

      for (var i = 0; i < this.week.length; i++) {
        if (this.week[i]) {
          this.week[i] = 1;
        } else {
          this.week[i] = 0;
        }
      }
      this.form.weekStr = "";
      for (var i = 0; i < this.week.length; i++) {
        this.form.weekStr += this.week[i];
      }
      var date = new Date(this.form.startTime);
      var h = date.getHours();
      var m = date.getMinutes();
      var s = date.getSeconds();
      var start_time =h+":"+m+":"+s;
      var j = 0;
      var len = 0;
      var arrseed = [];
      var seedidlist = this.form.seedlist.value.join("|");
      var arrfile = [];
      for (var i in this.form.filelist.value) {
        arrfile.push(this.form.filelist.value[i]);
      }
      var fileidlist = arrfile.join("|");
      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("token", sessionStorage.getItem("token"));
      data.append("snids", seedidlist);
      data.append("fileids", fileidlist);
      data.append("weeks", this.form.weekStr);
      data.append("kind", this.form.num);
      // data.append("nodeid", this.form.nodeid);
      data.append("task_name", this.form.name);
      data.append("len", this.form.len);
      data.append("jiange", this.form.jiange);
      if(this.form.estartDate != ""){
        data.append("startdate", this.form.estartDate);
      }
      if(this.form.eendDate != ""){
        data.append("enddate", this.form.eendDate);
      }
      data.append("start_time", start_time);
      axios
        .post("/user/add_task", data)
        .then(
          function(res) {
            if (res.data.res) {
              this._get_timer_tasklist();
            } else {
              this.$notify.success({
                title: "Info",
                message: "添加出现异常",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
      this.dialogVisible_addtask = false;
      this.form = {
        id: "",
        name: "",
        nodeid: "",
        startDate: "",
        endDate: "",
        estartDate: 0,
        eendDate: 0,
        kind: "1",
        num: 1,
        startTime: {},
        timepicker: [new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)],
        len: 0,
        weekStr: "",
        seedlist: {
          data: [],
          value: []
        },
        filelist: {
          data: [],
          value: []
        }
      };
    },
    creatTask() {
      this.dialog_titel = "创建任务";
      this.form.isedit_mode = false;
      this.form.jiange =1;
      this.nodechange_();
      this.get_file_list();
      this.dialogVisible_addtask = true;
      this.week = [true, true, true, true, true, true, true];
      this.form.startDate = "";
      this.form.endDate = "";
      this.is_create = true;
      this.form.startTime = "";
    },
    get_file_list() {
      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("token", sessionStorage.getItem("token"));
      axios
        .post("/user/listfile", data )
        .then(
          function(res) {

            if (res.data.res) {
              this.tableDatafilelist = res.data.filelist;
              if(this.tableDatafilelist.length > 0 ){
                var data = [];
                this.tableDatafilelist.forEach((item, index) => {
                    data.push({
                      key: item.id,
                      label: item.filename
                    });
                });
                this.form.filelist.data = data;
                this.$forceUpdate();
              }
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    nodechange_() {
      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("token", sessionStorage.getItem("token"));//http://swkj.ployq.com/user/fnckukei/listmydevice
      axios
        .post("/user/listdev",  data )
        .then(
          function(res) {
            console.log(res.data);
            if (res.data.res) {
              if(res.data.devlist.length  > 0){
                  var dev_info=[];
                  res.data.devlist.forEach((item,index)=>{
                    var obs = {};
                    obs.device_name = item.device_name;
                    obs.device_seed = item.device_seed;
                    obs.id = item.id;
                    obs.key = item.id;
                    obs.label = item.device_name;
                    dev_info.push(obs);
                  });
                  this.form.seedlist.data=dev_info;
              }
              //this.form.seedlist.data = res.data.dev_info;
              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    deletetask(index, rows) {
        if (rows[index].enable != "0") {
          this.$message({
            type: "warning",
            message: "请先禁用该任务"
          });
          return;
        }
        this.$confirm(
          "此操作将永久删除该任務, 是否继续?" + rows[index].task_name,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        ).then(function() {
          console.log(rows[index].enable);
          let task_id = rows[index].id;
          let data = new FormData();
          data.append("id", sessionStorage.getItem("id"));
          data.append("token", sessionStorage.getItem("token"));
          data.append("taskid", task_id );
          axios
            .post("/user/del_task", data )
            .then(
              function(res) {
                if (res.data.res) {
                  rows.splice(index, 1);
                  this._get_timer_tasklist();
                  this.$message({
                    type: "success",
                    message: "删除成功!" + filename
                  });
                }
              }.bind(this)
            )
            .catch(function(res) {
              console.log(res);
            });
        })
        .catch(() => {});
    },
    abletask(index, rows) {
      let task_id = rows[index].id;
      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("token", sessionStorage.getItem("token"));
      data.append("taskid", task_id );
      this.loading = true;
      if(rows[index].enable == "1"){
          axios
            .post("/user/enabletask",  data )
            .then(
              function(res) {
                this.loading = false;
                if (res.data.res) {
                    this.$alert('任务生效了到时间点执行自动播放', '提示：'+rows[index].task_name, { confirmButtonText: '确定'});
                }
              }.bind(this)
            ).catch(function(res) {
              console.log(res);
            });
      }else{
          axios
            .post("/user/disabletask",  data )
            .then(
              function(res) {
                this.loading = false;
                if (res.data.res) {
                  this.$alert('任务停止运行，到点不会播放', '提示：'+rows[index].task_name, {confirmButtonText: '确定' });
                }
              }.bind(this)
            ).catch(function(res) {
              console.log(res);
            });
      }
    },
    _get_timer_tasklist() {
      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("token", sessionStorage.getItem("token"));
      axios
        .post("/user/list_task",  data )
        .then(
          function(res) {
            if (res.data.res) {
              this.tableDatatasklist = res.data.taskary;
              this.tableDatatasklist.forEach((item,index)=>{
                  if(item.enable == 1){
                    item.enable = "1"
                  }else{
                    item.enable = "0"
                  }
              });
            }
          }.bind(this)
        ).catch(function(res) {
          console.log(res);
        });
    },
    gotimesave(){
      var localtc= new Date();
      this.localtime =  localtc.toString();
      var localtc= new Date(this.localtime);
      console.log("=>");
      console.log(localtc);
      var dss = new Date(localtc.getTime());
      console.log(dss.toString());
      axios
        .get("/save_nsptime.php?tc="+dss.getTime()).then(
          function(res) {
            if (res.data.res) {
                this.get_nsptime();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });

    },
    get_nsptime(){
      axios
        .get("/get_nsptime.php")
        .then(
          function(res) {
            if (res.data.res) {
               this.nsptime= res.data.time;
               //console.log(this.nsptime);
               this.systemtime = res.data.time;
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });

    },
    countfuck(){

    },
	  countLength(){
		 var  lenmusic = 0;
		 var filelllist =this.tableDatafilelist;
		 this.form.filelist.value.forEach( function(item){
			filelllist.forEach(function(jitem){
				if(jitem.id == item){
					lenmusic = Number(lenmusic)+ Number(jitem.len);
				}
			})
        });
		var jiangelen = Number(this.form.jiange)*Number(this.form.num);
		lenmusic = Number(lenmusic)*Number(this.form.num);
		this.form.len = Number(jiangelen)+Number(lenmusic);

	  },
	  Timerpickerchange(){
		  console.log(this.form.startTime);
	  },
	  handleTransfer(type, data, callback) {
	    if (type == 'left') {
	      this.form.filelist.data = this.form.filelist.data.concat(this.form.filelist.value[data]);
	    } else {
	      this.form.filelist.value = this.form.filelist.value.concat(this.form.filelist.data[data])
	    }
	    this[type + 'Data'].splice(data, 1);
	    callback(type);
	  },
	  handleSort(type, sortType, data, callback) {
	    if (!sortType || sortType == 'right') {
	      if (type == 'up') {
	        this.form.filelist.data = this.swapItems(this.form.filelist.data, data[1], data[1] - 1)
	        callback(sortType, [data[0], data[1] - 1]);
	      } else {
	        this.form.filelist.data = this.swapItems(this.form.filelist.data, data[1], data[1] + 1)
	        callback(sortType, [data[0], data[1] + 1])
	      }
	    } else if (sortType == 'left') {
	      if (type == 'up') {
	        this.form.filelist.value = this.swapItems(this.form.filelist.value, data[0], data[0] - 1)
	        callback(sortType, [data[0] - 1, data[1]]);
	      } else {
	        this.form.filelist.value = this.swapItems(this.form.filelist.value, data[0], data[0] + 1)
	        callback(sortType, [data[0] + 1, data[1]])
	      }
	    } else if (sortType == 'both') {
	      if (type == 'up') {
	        data[0] == 0 ? '' : this.form.filelist.value = this.swapItems(this.form.filelist.value, data[0], data[0] - 1)
	        data[1] == 0 ? '' : this.form.filelist.data = this.swapItems(this.form.filelist.data, data[1], data[1] - 1)
	        callback(sortType, [data[0] == 0 ? data[0] : (data[0] - 1), data[1] == 0 ?  data[1] : (data[1] - 1)]);
	      } else {
	        data[0] == (this.form.filelist.value.length - 1) ? '' : this.form.filelist.value = this.swapItems(this.form.filelist.value, data[0], data[0] + 1)
	        data[1] == (this.form.filelist.data.length - 1) ? '' : this.form.filelist.data = this.swapItems(this.form.filelist.data, data[1], data[1] + 1)
	        callback(sortType, [data[0] == (this.form.filelist.value.length - 1) ? data[0] : (data[0] + 1), data[1] == (this.form.filelist.data.length - 1) ? data[1] : (data[1] + 1)])
	      }
	    }
	  },
	  swapItems(arr, index1, index2) {
	    arr[index1] = arr.splice(index2, 1, arr[index1])[0];
	    return arr;
	  },
	rightCheck(selectionKeys, changeKeys){
            	this.tempSelectionKeys = selectionKeys;
            	if(selectionKeys.length > 0){
            		this.upDownDisable = false;
            	}else{
            		this.upDownDisable = true;
            	}
            },
            upData(){
				if(this.tempSelectionKeys.length > 1){
					this.$message({
						type: 'warning',
						message: '仅支持单选调顺序'
					});
					return ;
				}
            	let indexNum = 0;
            	for(let i=0; i<this.tempSelectionKeys.length; i++){
            		indexNum = this.form.filelist.value.indexOf(this.tempSelectionKeys[i])
            		if(indexNum > 0){
            			this.form.filelist.value.splice(indexNum - 1, 0, this.tempSelectionKeys[i]);
            			this.form.filelist.value.splice(indexNum + 1, 1);
            		}
            	}
            },
    downData(){
      if(this.tempSelectionKeys.length > 1){
        this.$message({
          type: 'warning',
          message: '仅支持单选调顺序'
        });
        return ;
      }
      let indexNum = 0;
      for(let i=0; i<this.tempSelectionKeys.length; i++){
        indexNum = this.form.filelist.value.indexOf(this.tempSelectionKeys[i]);
        if(indexNum > -1 && indexNum != this.form.filelist.value.length - 1){
          this.form.filelist.value.splice(indexNum + 2, 0, this.tempSelectionKeys[i]);
          this.form.filelist.value.splice(indexNum, 1);
        }
      }
    },
    task_mode_change() {
      if(this.form.kind == "0") {
          this.form.num = 0;
          this.form.jiange = 0;
              if(this.form.len<10){
            this.form.len=10;
        }
      }else{
        this.form.num = 1;
        this.form.len = 0;
      }
    },
    get_taskgroup_ap(){
        let data = new FormData();
        data.append("id", sessionStorage.getItem("id"));
        data.append("token", sessionStorage.getItem("token"));
        axios
          .post("/user/listplant",data)
          .then(
            function(res) {
              if (res.data.res) {
                 // this.options_taskgroup = res.data.data;
                 this.options_taskgroup = [];
                if(res.data.list.length > 0){
                  res.data.list.forEach( (item,index)=>{
                    this.options_taskgroup.push({"value":item.pid,"label":item.pname});
                    this.taskgpnamelist[item.pid] = item.pname
                  });
                }
              }
            }.bind(this)
          )
          .catch(function(res) {
            console.log(res);
          });
    },
    _eab_taskgroup(){
      if(this.taskgroupv == 0){
        return;
      }
      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("token", sessionStorage.getItem("token"));
      data.append("pid", this.taskgroupv );
       axios
         .post("/user/plantenable",data)
         .then(
           function(res) {
             if (res.data.res) {
                this.$alert("应用成功[Apply suc]");
                this.dialogVisible_edgtaskgroup = false;
                this._get_timer_tasklist();
             }else{
                this.$alert("Sth ER");
             }
           }.bind(this)
         )
         .catch(function(res) {
           console.log(res);
         });
    },
    _disab_taskgroup(){
      if(this.taskgroupv == 0){
        return;
      }
      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("token", sessionStorage.getItem("token"));
      data.append("pid", this.taskgroupv );
       axios
         .post("/user/plantdisable",  data )
         .then(
           function(res) {
             if (res.data.res) {
                this.$alert("应用成功[Apply suc]");
                this.dialogVisible_edgtaskgroup = false;
                this._get_timer_tasklist();
             }else{
                this.$alert("Sth ER");
             }
           }.bind(this)
         )
         .catch(function(res) {
           console.log(res);
         });
    },
    _edg_taskgroup_ap(){
      if(this.edgtaskid == 0){
        return;
      }
      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("token", sessionStorage.getItem("token"));
      data.append("pid", this.taskgroupvv );
      data.append("taskid", this.edgtaskid );
      axios
        .post("/user/plantedittask",  data)
        .then(
          function(res) {
            if (res.data.res) {
               this.$alert("应用成功[Apply suc]");
               this.dialogVisible_edgtaskgroup = false;
               this._get_timer_tasklist();
            }else{
               this.$alert("Sth ER");
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });

    },
    _add_taskgroup_ap(){
      let newgn = "";
      if(this.NewtaskGoupname.length>0){
          newgn = this.NewtaskGoupname;
      }else{
        return;
      }
      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("token", sessionStorage.getItem("token"));
      data.append("pname",newgn );
        axios
          .post("/user/addplant", data)
          .then(
            function(res) {
              if (res.data.res) {
                 this.$alert("添加成功[add suc]");
                 this.dialogVisible_addtaskgroup = false;
                 this.get_taskgroup_ap();
              }else{
                 this.$alert("名字重复重新取名[tName was used]");
              }
            }.bind(this)
          )
          .catch(function(res) {
            console.log(res);
          });

    },
    _del_taskgroup_ap(){
      let newgn = "";
      if(this.taskgroupv == 0){

        return;
      }
      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("token", sessionStorage.getItem("token"));
      data.append("pid", this.taskgroupv);
        axios
          .post("/user/deleteplant", data )
          .then(
            function(res) {
              if (res.data.res) {
                 this.$alert("删除成功[delete suc]");
                 this.taskgroupv = 0;
                 this.get_taskgroup_ap();
              }else{
                 this.$alert("删除失败[delete FALSE]");
              }
            }.bind(this)
          )
          .catch(function(res) {
            console.log(res);
          });

    },
    _add_taskgroup(){
      this.dialogVisible_addtaskgroup = true;
    },
    filterMethod(query, item) {
      return item.pinyin.indexOf(query) > -1;
    },
    kind_change(data) {
      if (data === "1") {
        this.timepickerVisible = true;
      } else {
        this.timepickerVisible = false;
      }
    },
    str_pull(data) {
      let str = "";
      data.forEach((item, index) => {
        str += item;
        str += "|";
      });
      return str.substring(0, str.length - 1);
    },
    add_taskadd() {
      this.dialog_titel = "添加任务";
          axios
              .get("/get_addtask_needs.php")
              .then(
                function(res) {
                  if (res.data.res) {
                    this.form.data2 = res.data.devices;
                    this.form.data3 = res.data.files;
                    this.form.data3.forEach((item, index) => {
                      this.form.data3[index].label = Base64.decode(item.label);
                    });
                    this.dialogVisible_addtask = true;
                    this.$forceUpdate();
                  }
                }.bind(this)
              )
              .catch(function(res) {
                console.log(res);
              });
          },
          deletetaskS(index, rows) {
          console.log(index);
          console.log(rows);
     },

    edgtask(index, rows) {
      this.edgtaskid = rows[index].id;
      this.edgtaskname = rows[index].task_name;
      //this.taskgroupvv = rows[index].gid;
      this.dialogVisible_edgtaskgroup = true;
    },
    detailtask(index, rows) {
      this.dialog_titel = "查看/编辑 任务";
      axios
        .get("/get_task_detail.php", {
          params: {
            task_id: rows[index].id
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.form = res.data.dataJson;
              this.form.time = new Date(
                2019,
                2,
                2,
                res.data.dataJson.time.h,
                res.data.dataJson.time.m
              );
              axios
                .get("/get_addtask_needs.php")
                .then(
                  function(res) {
                    if (res.data.res) {
                      this.form.data2 = res.data.devices;
                      this.form.data3 = res.data.files;
                      this.form.data3.forEach((item, index) => {
                        this.form.data3[index].label = Base64.decode(
                          item.label
                        );
                      });
                      this.dialogVisible_addtask = true;
                      this.$forceUpdate();
                    }
                  }.bind(this)
                )
                .catch(function(res) {
                  console.log(res);
                });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    _get_timer_tasklist_s( e,i) {
      axios
        .get("/Get_list_of_time_task.php")
        .then(
          function(res) {
            if (res.data.res) {
              console.log(res);
              this.tableDatatasklist = res.data.dataJson;
              if (e === "1") {
                this.$message({
                  type: "success",
                  message: "已生效!" + this.tableDatatasklist[i].task_name
                });
              } else {
                this.$message({
                  type: "success",
                  message: "已经禁用!" + this.tableDatatasklist[i].task_name
                });
              }
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    get_devlist: function() {
      axios
        .get("/get_user_node.php", {
          params: {
            username: sessionStorage.getItem("username"),
            passwd: sessionStorage.getItem("passwd")
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.tableData1 = res.data.dataJson;
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },

  }
};
</script>

<style   scoped>
.topbuttn {
  width: 200px;
}
#uoloaddiv {
  width: 1300px;
  margin: 20px auto;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.el-button .el-switch {
  margin-left: 20px;
}
.fucko{
  width: 1000px;
}
</style>



// WEBPACK FOOTER //
// src/xxxvue/task_list.vue